import { useQuery, useMutation } from '@tanstack/react-query';
import { keys } from '@/lib/queryKeys';
import { searchAdmissions, fetchActiveOrders, createIpPharmacySale, type IpPharmacySaleInput } from './api';

export function useAdmissionSearch(q: string) {
  return useQuery({
    queryKey: keys.pharmacy.ipAdmissionSearch(q),
    queryFn: () => searchAdmissions(q),
    enabled: q.trim().length >= 2,
  });
}

export function useAdmissionActiveOrders(admissionId: number | null) {
  return useQuery({
    queryKey: keys.pharmacy.ipActiveOrders(admissionId ?? 0),
    queryFn: () => fetchActiveOrders(admissionId as number),
    enabled: admissionId != null,
  });
}

export function useCreateIpPharmacySale() {
  return useMutation({
    mutationFn: (v: { admissionId: number; input: IpPharmacySaleInput }) => createIpPharmacySale(v.admissionId, v.input),
  });
}
